import { atom } from "jotai";
import { DEFAULT_SB_FOR_CLUSTERS } from "../utils/Constants";
import { companyProviderRestrictionConfigAtom } from "./atoms";
export const selectedBookingForRescheduleAtom = atom(null);
export const selectedRescheduleDateTimeAtom = atom(null); // suggested or non-suggested
export const suggestionLookAheadStartDateAtom = atom(null);
export const storedSuggestionsAtom = atom(null);
export const providerUnavaialbleTimeBlocksAtom = atom([]);
export const bookingGeoLocationAtom = atom(null);
// export const loadSuggestionsAtom = atom(false);
export const providerRescheduleAtom = atom({
    providerSBs: [DEFAULT_SB_FOR_CLUSTERS],
    showNormalSlots: false
});

export const getCurrentBookingClientNameAtom = atom((get) => {
    const booking = get(selectedBookingForRescheduleAtom);
    const providerRestriction = get(companyProviderRestrictionConfigAtom);
    return booking
        ? providerRestriction.canProviderSeeClientName
            ? `${booking.clientFirstName} ${booking.clientLastName}`
            : `${booking.clientFirstName}`
        : "";
});

export const getCurrentBookingDateAtom = atom((get) => {
    return get(selectedBookingForRescheduleAtom).startdate;
});
export const getCurrentBookingDateAsDateAtom = atom((get) => {
    return new Date(get(selectedBookingForRescheduleAtom).startdate);
});
export const isRecurringBookingAtom = atom(
    (get) => get(selectedBookingForRescheduleAtom).orderType === "ONGOING"
);
const calendarDate = atom(null);
export const recurringRecheduleChoiceAtom = atom("SELECTED");
export const showRecurrenceSettingsSectionAtom = atom(
    (get) => get(recurringRecheduleChoiceAtom) === "ALL_FUTURE"
);
export const hideSuggestionsAtom = atom(
    (get) => get(recurringRecheduleChoiceAtom) === "ALL_FUTURE"
);
export const calendarDateAtom = atom(
    (get) => {
        if (get(calendarDate) === null) {
            if (
                new Date(
                    get(selectedBookingForRescheduleAtom).startdate
                ).getTime() < Date.now()
            ) {
                return new Date();
            } else
                return new Date(
                    get(selectedBookingForRescheduleAtom).startdate
                );
        } else return get(calendarDate);
    },
    (get, set, newCalendateDate) => {
        set(calendarDate, newCalendateDate);
    }
);

export const errorAtom = atom(false);
//TODO: None of these times work - reset selected suggested slot
